module.exports = __webpack_public_path__ + "static/media/icons-instagram.7e98a7ef.svg";